/** Static catalog of admin microservice permissions (microservice → group → permission names) */
export const ADMIN_PERMISSION_CATALOG = {
    Campaign: {
        campaign: [
            'can_view_campaigns',
            'can_view_logs',
            'can_view_payload',
            'can_view_clients',
            'can_view_failed_logs',
        ],
    },
    Email: {
        admins: [
            'can_view_event_reports',
            'can_view_domains',
            'can_view_graph_reports',
            'can_view_resource_reports',
            'can_view_ips',
            'can_toggle_domain',
            'can_manage_domain_ips',
            'can_update_mail_limit',
            'can_view_webhooks',
            'can_view_ip_reports',
            'can_export_ip_reports',
            'can_view_templates',
            'can_update_template_status',
            'can_view_template_reports',
            'can_export_template_report',
            'can_view_permissions',
            'can_view_users',
            'can_toggle_user',
            'can_view_activity_logs',
            'can_manage_reasons',
            'can_manage_webhooks',
            'can_view_user_activity_logs',
            'can_view_inbound_email_log',
            'can_view_inbound_emails',
            'can_view_otp_keywords',
            'can_edit_otp_keywords',
            'can_create_global_templates',
            'can_update_domain',
            'can_view_unique_domain_recipients',
            'can_edit_user_permissions',
            'can_edit_keywords',
            'can_view_keywords',
        ],
    },
    Hello: {
        bot: ['can_view_and_test_bot', 'can_edit_and_delete_bot'],
    },
    Numbers: {
        Numbers: ['can_migrate_numbers'],
    },
    OTPWidget: {
        OTP_INBOUND_COUNTRY_VALIDATION: ['view', 'update'],
        DIALPLAN: ['view', 'create_update'],
        DEFAULT_TEMPLATE_CONFIGURATIONS: ['view', 'create_update'],
    },
    RCS: {
        RCS: ['RCS_Template_Update', 'can_create_integration'],
    },
    Reports: {
        sms: [
            'msg91.reports.analytics.view',
            'msg91.reports.analytics.export',
            'msg91.reports.analytics.export.list',
            'msg91.reports.logs.view',
            'msg91.reports.logs.export',
            'msg91.reports.logs.export.list',
            'msg91.reports.revenue.view',
            'msg91.reports.revenue.export',
            'msg91.reports.vendor.view',
            'msg91.reports.vendor.export',
            'msg91.reports.sales.view',
        ],
        otp: [
            'msg91.reports.analytics.view',
            'msg91.reports.analytics.export',
            'msg91.reports.analytics.export.list',
            'msg91.reports.logs.view',
            'msg91.reports.logs.export',
            'msg91.reports.logs.export.list',
            'msg91.reports.revenue.view',
            'msg91.reports.revenue.export',
        ],
        mail: [
            'msg91.reports.analytics.view',
            'msg91.reports.analytics.export',
            'msg91.reports.analytics.export.list',
            'msg91.reports.logs.view',
            'msg91.reports.logs.export',
            'msg91.reports.logs.export.list',
        ],
        wa: [
            'msg91.reports.analytics.view',
            'msg91.reports.analytics.export',
            'msg91.reports.analytics.export.list',
            'msg91.reports.logs.view',
            'msg91.reports.logs.export',
            'msg91.reports.logs.export.list',
        ],
        voice: [
            'msg91.reports.analytics.view',
            'msg91.reports.analytics.export',
            'msg91.reports.analytics.export.list',
            'msg91.reports.logs.view',
            'msg91.reports.logs.export',
            'msg91.reports.logs.export.list',
        ],
        numbers: [
            'msg91.reports.analytics.view',
            'msg91.reports.analytics.export',
            'msg91.reports.analytics.export.list',
            'msg91.reports.logs.view',
            'msg91.reports.logs.export',
            'msg91.reports.logs.export.list',
        ],
        notification: [
            'msg91.reports.analytics.view',
            'msg91.reports.analytics.export',
            'msg91.reports.analytics.export.list',
            'msg91.reports.logs.view',
            'msg91.reports.logs.export',
            'msg91.reports.logs.export.list',
        ],
        widget: [
            'msg91.reports.analytics.view',
            'msg91.reports.analytics.export',
            'msg91.reports.analytics.export.list',
            'msg91.reports.logs.view',
            'msg91.reports.logs.export',
            'msg91.reports.logs.export.list',
        ],
        telegram: [
            'msg91.reports.analytics.view',
            'msg91.reports.analytics.export',
            'msg91.reports.analytics.export.list',
            'msg91.reports.logs.view',
            'msg91.reports.logs.export',
            'msg91.reports.logs.export.list',
        ],
        superAdmin: ['msg91.reports.superAdmin'],
        bot: ['msg91.reports.analytics.view'],
        sms_otp: ['msg91.reports.analytics.view', 'msg91.reports.analytics.export'],
        criticalScopes: ['msg91.reports.archive.logs.view'],
        rcs: [
            'msg91.reports.analytics.view',
            'msg91.reports.analytics.export',
            'msg91.reports.analytics.export.list',
            'msg91.reports.logs.view',
            'msg91.reports.logs.export',
            'msg91.reports.logs.export.list',
        ],
    },
    Subscription: {
        admin: [
            'can_view_plans',
            'can_view_subscriptions',
            'can_view_clients',
            'can_view_payment_logs',
            'can_view_services',
            'can_update_payment_logs',
            'can_update_plans',
            'can_update_services',
            'can_update_subscriptions',
            'can_create_plans',
            'can_create_services',
            'can_edit_admin_permissions',
            'can_retry_payment_logs',
            'can_assign_plans',
            'can_view_admin_permissions',
        ],
    },
} as const;

export type AdminPermissionMicroservice = keyof typeof ADMIN_PERMISSION_CATALOG;

/** Route data for AdminViewPermissionGuard */
export interface IAdminViewPermissionData {
    microservice: string;
    group: string;
    /** User needs at least one of these permissions in the group */
    anyOf: string[];
}
